export default function SelectAgencyDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSelectAgencyDialog = handleSelectAgencyDialog;
  vm.agency = vm.audit.agency;
  vm.agencyId = vm.audit.agencyId;
  vm.oAgency = { ...vm.audit.agency };
  vm.oAgencyId = vm.audit.agencyId;
  vm.oAgencyDeleted = false;

  _initEventListeners();
  _activate();

  /** *********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    if (vm.oAgencyId !== vm.agencyId && !vm.oAgencyDeleted) {
      vm.audit.agency = vm.oAgency;
      vm.audit.agencyId = vm.oAgencyId;
    }
    _closeDialog();
  }

  function handleSelectAgencyDialog() {
    vm.audit.agency = vm.agency;
    vm.audit.agencyId = vm.agencyId;
    _closeDialog();
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    loaderService.showViewLoader = false;
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _initEventListeners() {
    $scope.$on('selectAMAgency', (event, opt) => { _selectAgency(opt.agency); });
    $scope.$on('deselectAMAgency', () => { _clearAgency(); });
    $scope.$on('deletedAMAgency', (event, opt) => { _deleteAgency(opt.agency); });
    $scope.$on('updateAMAgency', (event, opt) => { _updateAgency(opt.agency); });
  }

  function _selectAgency(agency) {
    vm.agencyId = agency.agencyId;
    vm.agency = agency;
  }

  function _clearAgency() {
    vm.agencyId = 0;
    vm.agency = null;
  }

  function _deleteAgency(agency) {
    if (agency.agencyId === vm.oAgencyId) {
      vm.oAgencyDeleted = true;
    }
    vm.agencyId = 0;
    vm.agency = null;
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.selectAgencyDialog);
  }

  function _updateAgency(agency) {
    if (agency.agencyId === vm.oAgencyId) {
      vm.oAgency = { ...agency };
    }
  }
}

SelectAgencyDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'loaderService',
  'ssDialogService'
];
